<template>
  <transition name="dialogfade">
    <k-dialog
      :title="title"
      class="consumer-dialog confirm-dialog"
      @close="$emit('cancel')"
      @overlay-click="$emit('cancel')"
    >
      <p class="confirm-msg">{{ msg }}</p>
      <p v-if="note" class="confirm-note">Note: {{ note }}</p>

      <k-dialog-actions>
        <kbutton class="dialog__btn dialog__btn--close" @click="$emit('cancel')">No</kbutton>
        <kbutton class="dialog__btn dialog__btn--save" @click="$emit('confirm')">Yes</kbutton>
      </k-dialog-actions>
    </k-dialog>
  </transition>
</template>

<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { Button } from "@progress/kendo-vue-buttons";

export default {
  name: "ConfirmDialog",
  components: {
    "k-dialog": Dialog,
    "k-dialog-actions": DialogActionsBar,
    "kbutton": Button
  },
  props: {
  
    title: { type: String, default: "Please Confirm" },
    msg: { type: String, default: "" },
    note: { type: String, default: "" }
  }
};
</script>

<style src="@/assets/css/commandcenter/commandcenter.css"></style>
